import HttpClient from 'src/service/http-client.service';
import Storage from 'src/helper/storage/storage.helper';

PluginManager.register(
    'GeoTargetingModal',
    () => import('./plugins/geo-targeting-modal.plugin'),
    '[data-geo-targeting-modal]',
);

const openLanguageModal = () => {
    const languageModal = document.getElementById('languageModal');

    if (languageModal && Storage.getItem('languageModal') !== 'true') {
        const modal = new bootstrap.Modal(languageModal, {});
        modal.show();

        languageModal.addEventListener('hidden.bs.modal', (e) => {
            Storage.setItem('languageModal', 'true', 30);
        });

        languageModal.querySelector('form').addEventListener('submit', (e) => {
            Storage.setItem('languageModal', 'true', 30);
        });
    }
};

const isBot = () => {
    return /bot|google|baidu|bing|msn|teoma|slurp|yandex|lighthouse/i.test(navigator.userAgent);
};

if (!isBot()) {
    if (Storage.getItem('isRow', 'true') === 'true' || Storage.getItem('geoModal') !== 'true') {
        const client = new HttpClient();
        client.get(window.routerGeo, (response) => {
            const data = JSON.parse(response);
            if (data.salesChannel !== null) {
                if (data.salesChannel.isRow == true) {
                    Storage.setItem('isRow', 'true');
                    window.location.href = data.salesChannel.domains[0].url;
                    return;
                }

                const salesChannelName = document.getElementById('geoModalSalesChannelName');
                const salesChannelUrl = document.getElementById('geoModalSalesChannelUrl');
                const geoModal = document.getElementById('geoModal');

                if (!salesChannelName || !salesChannelUrl || !geoModal) {
                    return;
                }

                salesChannelName.innerHTML = data.salesChannel.name;

                let redirpath = '';
                let isSearch = (window.location.search.match(new RegExp('[?&]' + 'search' + '=([^&]+)')) || [
                    ,
                    null,
                ])[1];

                if (isSearch) {
                    redirpath = '/search?search=' + isSearch;
                }

                salesChannelUrl.innerHTML = data.salesChannel.name.replace(/GO\sIN/, '').trim();
                salesChannelUrl.href = data.salesChannel.domains[0].url + redirpath;

                // Preserve URL parameters
                const url = new URL(salesChannelUrl.href);
                Object.keys(Object.fromEntries(new URLSearchParams(window.location.search))).forEach((key) => {
                    if (!url.searchParams.has(key)) {
                        url.searchParams.append(
                            key,
                            Object.fromEntries(new URLSearchParams(window.location.search))[key],
                        );
                    }
                });
                salesChannelUrl.href = url.toString();

                const modal = new bootstrap.Modal(geoModal, {});
                modal.show();

                geoModal.addEventListener('hidden.bs.modal', (e) => {
                    Storage.setItem('geoModal', 'true', 7);
                    openLanguageModal();
                });
            } else {
                Storage.setItem('geoModal', 'true', 7);
            }
        });
    } else {
        openLanguageModal();
    }
}
